// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-duties .uk-table caption{padding:7px 12px;font-weight:700}.details-duties .image{min-width:75px;height:auto;aspect-ratio:4/3;position:relative;overflow:hidden;border:1px solid #0000001a;padding:5px;box-sizing:unset}.details-duties .image img{width:75px}.details-duties .name,.details-duties .price{vertical-align:middle}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
